import { takeLatest, put, fork, call } from 'redux-saga/effects';

import { handlePostCognitoLogin } from '../authSharedSagas';
import { Types, signInFail } from './actions';
import { cognitoSignIn } from '@services/cognitoUserService';
import { handleCognitoSignInNonSuccess } from './cognitoSignInUtils';

function* callPostSignIn(action) {
  try {
    const { email, password } = action.payload;
    const cognitoResult = yield call(cognitoSignIn, email, password);
    if (!cognitoResult.success) {
      const result = yield* handleCognitoSignInNonSuccess({
        email,
        cognitoResult,
      });
      if (result?.handled) return;

      throw new Error(result?.errorMessage || 'Cognito sign-in failed');
    }
    // Persist Cognito JWT so subsequent API requests include it in headers.
    yield* handlePostCognitoLogin({
      cognitoSub: cognitoResult.payload.cognitoSub,
      token: cognitoResult.payload.token,
      email,
    });
  } catch (error) {
    yield put(signInFail(error.message));
  }
}

function* watchCallPostSignIn() {
  yield takeLatest(Types.SIGN_IN, callPostSignIn);
}

export default function* watchLoginSignInActions() {
  yield fork(watchCallPostSignIn);
}
